import { ButtonBack } from './ButtonBack';
import { ButtonClose } from './ButtonClose';
import { Confirm } from './Confirm';
import { Drawer } from './Drawer';
import { Group } from './Group';
import { Item } from './Item';
import { Menu } from './Menu';
import { Prompt } from './Prompt';
import { Wrapper } from './Wrapper';
export default {
    Menu,
    Drawer,
    Group,
    Item,
    ButtonBack,
    ButtonClose,
    Prompt,
    Wrapper,
    Confirm,
};
